module.exports = __webpack_public_path__ + "img/icon_vip_priority loan@3x(1).d5e15449.png";